import "bootstrap/dist/css/bootstrap.min.css";
import "bootstrap";
import { createApp } from "vue";
import { defineRule } from "vee-validate";
import { required, email, min, confirmed } from "@vee-validate/rules";
import App from "./App.vue";
import router from "./router";
import ApiService from "./services/ApiService";
import authStorage from "./utils/authStorage";

defineRule("required", required);
defineRule("email", email);
defineRule("min", min);
defineRule("confirmed", confirmed);

ApiService.setLogoutCallback(() => {
  authStorage.clearSession();
  router.push({ name: "login" });
});

const app = createApp(App);
app.use(router);
app.mount("#app");
